/* ===========================================================================
   BN — Bundle Carousel controller
   ---------------------------------------------------------------------------
   One idempotent controller for every instance on the page. The rail scrolls
   natively; this only wires the arrows and keeps their disabled state honest.

   Idempotent because the Theme Editor re-renders a section's HTML on every
   settings change and fires `shopify:section:load` — binding blindly would
   stack a fresh set of listeners onto each edit. Instances are marked once
   and skipped thereafter.
   =========================================================================== */
(function () {
  'use strict';

  var INIT_FLAG = 'bnCarouselReady';

  function edge(rail) {
    // A rail scrolled to its end can sit a fraction of a pixel short on
    // fractional-DPI displays, so compare with a tolerance rather than ===.
    var max = rail.scrollWidth - rail.clientWidth;
    return {
      atStart: rail.scrollLeft <= 1,
      atEnd: rail.scrollLeft >= max - 1,
      scrollable: max > 1
    };
  }

  function init(root) {
    var rail = root.querySelector('[data-bn-carousel-rail]');
    if (!rail || rail.dataset[INIT_FLAG]) return;
    rail.dataset[INIT_FLAG] = '1';

    var prev = root.querySelector('[data-bn-carousel-prev]');
    var next = root.querySelector('[data-bn-carousel-next]');

    function step() {
      // Advance by whole cards so a slide never comes to rest half-shown.
      // `[data-bn-carousel-card]` is the general contract, used by the homepage
      // merchandising rails; `.bn-carousel-card` is kept as a fallback for the
      // two bundle carousels that predate the attribute.
      var card = rail.querySelector('[data-bn-carousel-card]') ||
                 rail.querySelector('.bn-carousel-card');
      if (!card) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var e = edge(rail);
      if (prev) prev.disabled = e.atStart || !e.scrollable;
      if (next) next.disabled = e.atEnd || !e.scrollable;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'auto' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'auto' });
      });
    }

    rail.addEventListener('scroll', function () {
      // Coalesce the scroll burst into one state update per frame.
      if (rail._bnFrame) return;
      rail._bnFrame = requestAnimationFrame(function () {
        rail._bnFrame = null;
        sync();
      });
    }, { passive: true });

    if ('ResizeObserver' in window) {
      // A viewport change alters how many cards fit, which can make a rail
      // that needed arrows stop needing them.
      new ResizeObserver(sync).observe(rail);
    }

    sync();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-bn-carousel]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
